import endpoints, { axios } from "../config/api";

async function deleteTask(projectId: number, taskId: number) {
  return axios.delete(endpoints.task.delete(projectId, taskId));
}

export default deleteTask;
